import { Model } from '@hub-components';

export interface MapStateDrilldownJSON {
  widget_id: number;
  state: string;
}

export class MapStateDrilldown extends Model {
  widgetId: number;
  state: string;

  constructor(obj: Partial<MapStateDrilldownJSON> = {}) {
    super(obj);
  }

  public asJson(): MapStateDrilldownJSON {
    return {
      widget_id: this.widgetId,
      state: this.state,
    };
  }
}
